var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 60.5C120 76.413 113.679 91.6742 102.426 102.926C91.1742 114.179 75.913 120.5 60 120.5C44.087 120.5 28.8258 114.179 17.5736 102.926C6.32141 91.6742 0 76.413 0 60.5C0 44.587 6.32141 29.3258 17.5736 18.0736C28.8258 6.82141 44.087 0.5 60 0.5C75.913 0.5 91.1742 6.82141 102.426 18.0736C113.679 29.3258 120 44.587 120 60.5ZM90.225 37.775C89.6893 37.2411 89.0514 36.8208 88.3495 36.5391C87.6476 36.2574 86.8961 36.1202 86.1399 36.1356C85.3838 36.151 84.6385 36.3187 83.9486 36.6288C83.2588 36.9388 82.6385 37.3848 82.125 37.94L56.0775 71.1275L40.38 55.4225C39.3137 54.4289 37.9033 53.888 36.4461 53.9137C34.9888 53.9394 33.5984 54.5297 32.5678 55.5603C31.5372 56.5909 30.9469 57.9813 30.9212 59.4386C30.8955 60.8958 31.4364 62.3062 32.43 63.3725L52.275 83.225C52.8096 83.7586 53.4462 84.1791 54.1469 84.4614C54.8475 84.7437 55.5979 84.8819 56.3531 84.8679C57.1083 84.8539 57.853 84.688 58.5427 84.3799C59.2324 84.0719 59.853 83.6281 60.3675 83.075L90.3075 45.65C91.3282 44.5887 91.8921 43.1696 91.878 41.6972C91.864 40.2248 91.2732 38.8166 90.2325 37.775H90.225Z",
    fill: "#34C98E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSuccess);
export default __webpack_public_path__ + "static/media/order-success.2afed80efa6bb402cb68a0a75bc19fe0.svg";
export { ForwardRef as ReactComponent };